import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ErpParams {
  id?: number;          // ext_statement_id – används vid PUT
  statement_id?: number; // kitstajm statement_id – används vid POST
  redirect_uri?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ErpService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  // POST /api/erpinvoice?statement_id=...
  // redirect_uri skickas i bodyn för att undvika att Restify normaliserar bort ett snedstreck i query-strängen (http:// → http:/)
  save(params: ErpParams, body: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params.statement_id) httpParams = httpParams.set('statement_id', String(params.statement_id));

    const mergedBody = params.redirect_uri ? { ...body, redirect_uri: params.redirect_uri } : body;
    return this.http.post<any>('/api/erpinvoice', mergedBody, { params: httpParams });
  }

  // PUT /api/erpinvoice/:id
  // redirect_uri skickas i bodyn av samma anledning som ovan
  update(params: ErpParams, body: any): Observable<any> {
    const mergedBody = params.redirect_uri ? { ...body, redirect_uri: params.redirect_uri } : body;
    return this.http.put<any>(`/api/erpinvoice/${params.id}`, mergedBody);
  }
}
